import React from 'react';
import { CheckCircle2, Timer, ListChecks, Shield, Moon } from 'lucide-react';
export function ContentPreview() {
  const contents = [{
    icon: <ListChecks className="w-6 h-6 text-gold-500" data-id="element-100" />,
    title: "Plantilla del Bloque CIERRE 90'",
    description: 'Eliges 1 tarea que importa, la conviertes en micro-pasos y ejecutas sin improvisar.'
  }, {
    icon: <Timer className="w-6 h-6 text-gold-500" data-id="element-101" />,
    title: 'Timers listos para oficina',
    description: '25/5 (alta interrupción) y 52/17 (producción real). Listos para usar.'
  }, {
    icon: <Shield className="w-6 h-6 text-gold-500" data-id="element-102" />,
    title: 'Checklist anti-interrupciones',
    description: 'Qué cortar, qué silenciar, qué dejar por lote (email, chat, reuniones).'
  }, {
    icon: <CheckCircle2 className="w-6 h-6 text-gold-500" data-id="element-103" />,
    title: 'Protocolo de retorno',
    description: 'El problema no es que te interrumpan. El problema es no saber volver.'
  }, {
    icon: <Moon className="w-6 h-6 text-gold-500" data-id="element-104" />,
    title: 'Cierre de día (5 minutos)',
    description: 'Para apagar la cabeza con un cierre real, no con cansancio.'
  }];
  return <section className="py-24 bg-black relative" data-id="element-105">
      <div className="max-w-7xl mx-auto px-4" data-id="element-106">
        <div className="text-center mb-16" data-id="element-107">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-108">
            <span className="text-white" data-id="element-109">Qué incluye </span>
            <span className="text-gold-500 font-serif italic" data-id="element-110">por dentro</span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-111">
            Sin relleno. Solo herramientas que funcionan.
          </p>
        </div>

        <div className="mb-16 max-w-5xl mx-auto" data-id="element-112">
          <div className="relative rounded-2xl overflow-hidden border border-gold-500/30 shadow-2xl" data-id="element-113">
            <img src="https://cdn.magicpatterns.com/uploads/rapAdR9UYWKjTUv8dhRhM9/3_From_chaos_to_productivity.png" alt="Transformación: Del caos a la productividad" className="w-full h-auto" data-id="element-114" />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black via-black/80 to-transparent p-8 text-center" data-id="element-115">
              <p className="text-2xl font-serif text-gold-500 italic" data-id="element-116">
                Del caos al control. La transformación es visual.
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-117">
          {contents.map((item, index) => <div key={index} className="bg-dark-900 p-6 rounded-xl border border-white/5 hover:border-gold-500/30 transition-all duration-300 group" data-id="element-118">
              <div className="w-12 h-12 bg-black rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 border border-white/10" data-id="element-119">
                {item.icon}
              </div>
              <h3 className="text-lg font-bold text-white mb-3" data-id="element-120">
                {item.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-121">
                {item.description}
              </p>
            </div>)}
        </div>

        <div className="bg-dark-900 rounded-2xl p-8 md:p-12 border border-gold-500/20 text-center" data-id="element-122">
          <h3 className="text-2xl font-bold text-white mb-4" data-id="element-123">
            Lo que hace que esto funcione
          </h3>
          <p className="text-gray-300 text-lg leading-relaxed max-w-3xl mx-auto mb-6" data-id="element-124">
            La mayoría de métodos fallan por una razón:{' '}
            <span className="text-white font-semibold" data-id="element-125">
              Te piden controlar un día que no controlas
            </span>
            .
          </p>
          <p className="text-xl text-gold-500 font-serif italic" data-id="element-126">
            Este sistema asume la realidad: interrupciones existen, urgencias
            pasan, el inbox nunca termina.
          </p>
          <p className="text-gray-400 mt-4" data-id="element-127">
            Por eso el Método CIERRE 90' funciona: depende de{' '}
            <span className="text-white font-medium" data-id="element-128">estructura simple</span>,
            no de disciplina perfecta.
          </p>
        </div>
      </div>
    </section>;
}